import { useState } from 'react'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from 'react-chartjs-2';
import React from 'react'
import './MortgageCalculator.css'
import { Button } from '../Button';
import Result from '../Calculations';

ChartJS.register(ArcElement, Tooltip, Legend);

function MortgageCalculator() {

    const [data, setData] = useState({
        homeValue: 500000,
        downPayment: 0,
        interestTimeY: 5,
        interestTimeM: 0,
        interestRate: 4,
        paymentType: 'Monthly'
    })

  return (
    <div className='mortgage-calculator'>
        <div className='mortgage-details'>
            <h2>
                Mortgage Details
            </h2>
            <form>
                <div className='form-group'>
                    <label>
                        Home Value
                    </label>
                    <input type='text' placeholder={data.homeValue.toLocaleString()} className='mortgage-amount-input' onChange={(e) => setData(prev => ({...prev, homeValue: Number(e.target.value)}))}></input>
                </div>
                <div className='form-row'>
                    <div className='form-group'>
                        <label>Mortgage Length</label>
                        <div className='mortgage-length-input'>
                            <div>
                                <label className='mortgage-length-label'>Years</label>
                                <input type='text' placeholder={data.interestTimeY} className='mortgage-length-years' onChange={(e) => setData(prev => ({...prev, interestTimeY: Number(e.target.value)}))}></input>
                            </div>
                            <div>
                                <label className='mortgage-length-label'>Months</label>
                                <input type='text' placeholder={data.interestTimeM} className='mortgage-length-months' onChange={(e) => setData(prev => ({...prev, interestTimeM: Number(e.target.value)}))}></input>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='form-group'>
                    <label>Interest Rate</label>
                    <input type='text' placeholder={data.interestRate + "%"} className='mortgage-interest-rate' onChange={(e) => setData(prev => ({...prev, interestRate: Number(e.target.value)}))}></input>
                </div>
                <div className='form-row'>
                    <div className='form-group'>
                        <label>Down Payment</label>
                        <input type='text' placeholder={'$' + data.downPayment.toLocaleString()} className='lump-sum-payment' onChange={(e) => setData(prev => ({...prev, downPayment: Number(e.target.value)}))}></input>
                    </div>
                </div>
                <div className='form-group'>
                    <label>Payment Frequency</label>
                    <select className='mortgage-payment-frequency' onChange={(e) => setData(prev => ({...prev, paymentType: e.target.value}))}>
                        <option>Monthly</option>
                        <option>Yearly</option>
                    </select>
                </div>
            </form>
        </div>
        <div className='mortgage-scenario'>
            <h2 className='mortgage-scenario-title'>Mortgage Scenario</h2>
            <div className='scenario-summary'>
                <Result data={data}></Result>
                <div className='scenario-info'>
                    <label>
                        Mortgage Amount: {'$' + (data.homeValue - data.downPayment).toLocaleString(undefined, {maximumFractionDigits: 2})}
                    </label>
                    <label>
                        Mortgage Length: {data.interestTimeY} Years, {data.interestTimeM} Months
                    </label>
                    <label>
                        Interest Rate: {data.interestRate}%
                    </label>
                    <label>
                        Down Payment: ${data.downPayment.toLocaleString(undefined, {maximumFractionDigits: 2})}
                    </label>
                </div>   
            </div>
        </div>
        <div className='chart-section'>  
        </div>
    </div>
  )
}

export default MortgageCalculator